import './tokens-extra.css';
import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import { Icon } from '@/app/kit';
import type { IconName } from '@/app/module';
import { langProps, textOf } from './lang';
import { TONE_BG, type Tone } from './tones';

/**
 * Small skewed label: PROVISIONAL, RUSTY, LIVE, GUEST. Not interactive.
 *
 *   <Tag tone="butter">Provisional</Tag>
 *   <Tag tone="mint" icon="check">Checked in</Tag>
 */
export interface TagProps {
  children: ReactNode;
  tone?: Tone;
  icon?: IconName;
  className?: string;
}

export function Tag({ children, tone = 'white', icon, className }: TagProps) {
  return (
    <span className={clsx('tts-ui-tag', TONE_BG[tone], className)} {...langProps(textOf(children))}>
      <span className="inline-flex items-center gap-1">
        {icon && <Icon name={icon} size={12} strokeWidth={3} />}
        {children}
      </span>
    </span>
  );
}
